import { createFileRoute } from '@tanstack/react-router';
import { warehouseDirectorySearchSchema } from '@features/warehouse-inventory';

export const Route = createFileRoute('/$locale/_authenticated/warehouse/warehouses')({
  validateSearch: (search) => warehouseDirectorySearchSchema.parse(search),
});
